import {Component, computed, input, OnInit, output} from '@angular/core';
import {loadFull} from "tsparticles";
import {Engine} from "@tsparticles/engine";
import {NgParticlesService, NgxParticlesModule} from '@tsparticles/angular';
import {particlesConfettiOptions} from './tsparticles-confetti-options';
import {AdditionalConditionsType, CampaignType, locationDisplayFunction, RedeemedCampaign} from '../../services/model';
import {NgClass, NgOptimizedImage} from '@angular/common';
import {TranslocoDirective} from '@jsverse/transloco';
import {MatButtonModule} from '@angular/material/button';
import {GoogleMap, MapAdvancedMarker} from '@angular/google-maps';
import {LoyaltyCurrencyPipe} from '../pipes/loyalty-currency.pipe';

@Component({
  selector: 'lib-user-redeemed-success',
  templateUrl: './user-redeemed-success.component.html',
  styleUrl: './user-redeemed-success.component.scss',
  imports: [NgxParticlesModule, LoyaltyCurrencyPipe, TranslocoDirective, NgOptimizedImage, MatButtonModule, GoogleMap,
    MapAdvancedMarker, NgClass]
})
export class UserRedeemedSuccessComponent implements OnInit {
  confettiId = "tsparticles";

  redeemedCampaign = input.required<RedeemedCampaign>();
  campaignType = input.required<CampaignType>();

  onNavigateToHome = output<void>();

  mapOptions = {
    disableDefaultUI: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    clickableIcons: false,
    gestureHandling: 'greedy'
  } as google.maps.MapOptions;
  zoom = 15;


  locationDisplayString = computed(() => {
    return locationDisplayFunction(this.redeemedCampaign().location);
  });

  mapCenter = computed(() => {
    return {
      lat: this.redeemedCampaign().location.address.latitude,
      lng: this.redeemedCampaign().location.address.longitude
    }
  });

  markerContent = computed(() => {
    const content = document.createElement("div");
    content.classList.add("map-point-container");
    content.innerHTML = `<div></div>`;
    return content;
  });

  protected readonly particlesConfettiOptions = particlesConfettiOptions;

  constructor(private readonly ngParticlesService: NgParticlesService) {
  }

  ngOnInit(): void {
    void this.ngParticlesService.init(async (engine: Engine) => {
      await loadFull(engine);
    });
  }

  navigateToHome(): void {
    this.onNavigateToHome.emit();
  }

  protected readonly CampaignType = CampaignType;
  protected readonly AdditionalConditionsType = AdditionalConditionsType;
}
